let locales = {
    users_tab_subuser: 'Usuario',
    users_tab_email: 'Correo',
    users_tab_login_as_user: 'Iniciar sesión como usuario',
    users_tab_users: 'Usuarios',
    users_tab_warning_message_sm: 'Esta acción no está disponible para el usuario',
    users_tab_verify_tc: 'Verificar TC',
    users_tab_accepted: 'Aceptado',
    users_tab_pending: 'Pendiente',
    users_tab_reset_user_passowrd: 'Cambiar la contraseña ',
    users_tab_reset_user_email: 'Cambiar el correo electrónico',
    users_tab_resend_invite: 'Reenviar invitación',
    users_tab_chanage_username: 'Cambiar nombre de usuario',
    users_tab_warning_message_resend: 'La invitación de reenvío solo está disponible en el estado de registro caducado y pendiente',
    users_tab_show_activities: 'Mostrar actividades',
    users_tab_warning_message_reset_password: 'El cambio de contraseña solo está disponible en el estado de registro activo',
    users_tab_id: 'Id',

}

//Merge Views
import sendWelcomeEmail from 'Modules/users/.components/sendWelcomeEmail/lan/es';
import resetSubUserPassword from 'Modules/users/.components/resetSubUserPassword/lan/es';

locales = { ...locales, ...sendWelcomeEmail, ...resetSubUserPassword };

export default locales;
